import { looksLikePdf } from '../files/fileUtils';

export function parapheurCircuitPath(circuitId: string): string {
  return `/parapheur/${circuitId}`;
}

export type SignatureMailEvent = 'step_activated' | 'completed' | 'rejected' | 'cancelled';

/** Chemin CTA mail (préfixer avec APP_BASE_URL côté edge). */
export function parapheurMailPath(
  event: SignatureMailEvent,
  circuitId: string,
  dossierId?: string | null,
): string {
  if (event === 'completed' && dossierId) {
    return `/dossiers/${dossierId}/documents`;
  }
  return parapheurCircuitPath(circuitId);
}

export type CircuitPreviewKind = 'pdf' | 'unsupported' | 'missing';

export function circuitPreviewKind(
  file: { mime?: string | null; filename?: string | null } | null | undefined,
): CircuitPreviewKind {
  if (!file) return 'missing';
  if (looksLikePdf(file.mime, file.filename)) return 'pdf';
  return 'unsupported';
}
